import { render, staticRenderFns } from "./PagamentosFilter.vue?vue&type=template&id=406dc9b4"
import script from "./PagamentosFilter.vue?vue&type=script&lang=js"
export * from "./PagamentosFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports